import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, withCtx as _withCtx, toDisplayString as _toDisplayString, mergeProps as _mergeProps, toHandlers as _toHandlers, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/img/modal-confirmation/employment.svg'


const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = {
  key: 0,
  class: "content mt-16 mb-4 px-4"
}
const _hoisted_4 = { class: "lg:flex gap-4" }
const _hoisted_5 = { class: "lg:w-2/3" }
const _hoisted_6 = { class: "md:grid grid-cols-2 gap-8" }
const _hoisted_7 = { class: "mb-4" }
const _hoisted_8 = { class: "invalid-feedback" }
const _hoisted_9 = { class: "mb-4" }
const _hoisted_10 = { class: "invalid-feedback" }
const _hoisted_11 = { class: "md:grid grid-cols-2 gap-8" }
const _hoisted_12 = { class: "mb-4" }
const _hoisted_13 = { class: "invalid-feedback" }
const _hoisted_14 = { class: "mb-4" }
const _hoisted_15 = { class: "invalid-feedback" }
const _hoisted_16 = { class: "md:grid grid-cols-2 gap-8" }
const _hoisted_17 = { class: "mb-4" }
const _hoisted_18 = { class: "invalid-feedback" }
const _hoisted_19 = { class: "flex align-items-center mt-4 col-span-2" }
const _hoisted_20 = { class: "mb-4" }
const _hoisted_21 = { class: "invalid-feedback" }
const _hoisted_22 = { class: "md:grid grid-cols-2 gap-8" }
const _hoisted_23 = { class: "mb-4" }
const _hoisted_24 = { class: "invalid-feedback" }
const _hoisted_25 = { class: "lg:w-1/3" }
const _hoisted_26 = {
  class: "rounded-xl border-grey-4 p-4",
  style: {"height":"100%"}
}
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { class: "flex items-center gap-2 border-bottom-grey-4 pb-2" }
const _hoisted_29 = { class: "text-base" }
const _hoisted_30 = { class: "md:w-1/2 text-sm text-grey" }
const _hoisted_31 = { class: "md:w-1/2 text-right text-sm" }
const _hoisted_32 = {
  key: 1,
  class: "flex items-center justify-center"
}
const _hoisted_33 = { class: "md:grid grid-cols-2 gap-8" }
const _hoisted_34 = { class: "mb-4" }
const _hoisted_35 = { class: "p-inputgroup" }
const _hoisted_36 = { class: "invalid-feedback" }
const _hoisted_37 = { class: "mb-4" }
const _hoisted_38 = { class: "invalid-feedback" }
const _hoisted_39 = { class: "flex mt-auto float-right pt-16" }

import Button from 'primevue/button'
import Checkbox from 'primevue/checkbox'
import Dropdown from 'primevue/dropdown'
import InputText from 'primevue/inputtext'
import SelectAsync from '@/views/components/form/SelectAsync.vue'
import { DatePicker } from 'v-calendar'
import * as Yup from 'yup'
import { Form, Field } from 'vee-validate'
import { computed, getCurrentInstance, onBeforeMount, onMounted, ref } from 'vue'
import { useStore } from 'vuex'
import returnUrlPrams from '@/utils/helpers/returnUrlPrams'
import apiUseCase from '@/usecase/apiUseCase'
import rgxExp from '@/utils/helpers/regExp'
import { findLastKey, initial, valuesIn } from 'lodash'
import moment from 'moment'
import { useRoute } from 'vue-router'
import numberFormat from '@/utils/helpers/numberFormat'
import { encryptDecriptMethods } from '@/plugins/encryptDecriptMethods'
import EmployeeContractList from './editForm/EmployeeContractList.vue'

const moduleStore = 'hjpTable'
const employeeEndpoint = 'talent/v1/employees'
const employmentEndpoint = 'talent/v1/employments'
const positionEndpoint = '/talent/v1/positions'
const regionEndpoint = '/talent/v1/regions'
const buildingEndpoint = 'talent/v1/buildings'
const employmentTypesEndpoint = '/talent/v1/employmentTypes'

export default /*@__PURE__*/_defineComponent({
  __name: 'EmployeeContractForm',
  setup(__props) {

const store = useStore()
const route = useRoute()
let contract = {} as any
const dataForm = ref()
const dataFormLabel = ref()
const isEmploymentActive = ref()
const idPrams = ref(null) as any
const isLoading = ref(true)
const positionRequirementList = ref([]) as any
const app = getCurrentInstance()
const {
  $toast
} = app!.appContext.config.globalProperties

const initialValues = {
  Position: null as any,
  EmploymentType: null as any,
  Region: null as any,
  Building: null as any,
  StartDate: null as any,
  EndDate: null as any,
  Note: null as any,
  IsActive: true,
  BaseSalary: null as any,
  PaymentDay: null as any
}

const positionOptions = ref()
const regionOptions = ref()
const employmentTypeOptions = ref()

const schema = Yup.object().shape({
  Position: Yup.object()
    .required('Divisi wajib dipilih'),
  EmploymentType: Yup.object()
    .required('Jenis Kepegawaian wajib dipilih'),
  Region: Yup.object()
    .required('Wilayah Operasional wajib dipilih'),
  Building: Yup.object({
    id: Yup.string().required(),
    code: Yup.string().required(),
    name: Yup.string().required(),
    address: Yup.string().required(),
    isActive: Yup.boolean().required(),
    label: Yup.string().required()
  })
    .typeError('Gedung wajib dipilih')
    .required('Gedung wajib dipilih'),
  StartDate: Yup.string()
    .required('Tanggal Mulai wajib dipilih'),
  Note: Yup.string()
    .required('Keterangan wajib diisi'),
  BaseSalary: Yup.string()
    .nullable()
    // .required('Gaji per Bulan wajib diisi')
    .test('integer', 'Gaji per Bulan wajib berupa angka bulat', (value) => value == null || /^\d+$/.test(value) || value === '')
    .max(10, 'Gaji per Bulan maksimal 10 karakter'),
  PaymentDay: Yup.string()
    .nullable()
    // .required('Tanggal Pembayaran wajib diisi')
    .test('integer', 'Tanggal Pembayaran wajib berupa angka bulat', (value) => value == null || /^\d+$/.test(value) || value === '')
    // .test('not-zero', 'Tanggal Pembayaran tidak boleh 0', (value) => value == null || Number(value) > 0 || value === '')
    .test('max-day', 'Tanggal Pembayaran maksimal tanggal 31', (value) => value == null || Number(value) <= 31 || value === ''),
  // EndDate: Yup.date()
  //       .typeError('End Date is required')
  //       .required('End Date is required')
  //       .when('start_date', (StartDate) => {
  //           if (StartDate) {
  //               return Yup.date()
  //                   .min(StartDate, 'End Date must be after Start Date')
  //                   .typeError('End Date is required')
  //           }
  //       }),
})

const IsEmployeeActive = ref(false)

const toast = (status: any, message: any) => {
  $toast.add({
    severity: status,
    detail: message,
    group: 'bc',
    closable: false,
    life: 3000
  })
}

const processSubmit = async (val: any) => {
  store.dispatch('showLoading')
  console.log('val', val)

  dataForm.value = {
    employeeId: store.getters['employee/getEmployeeId'],
    employmentTypeId: val.EmploymentType.id,
    positionId: val.Position.id,
    regionId: val.Region.id,
    buildingId: val.Building.id,
    startDate: moment(val.StartDate).format('YYYY-MM-DD'),
    endDate: val.EndDate ? moment(val.EndDate).format('YYYY-MM-DD') : null,
    remarks: val.Note ? val.Note : '',
    isActive: IsEmployeeActive.value,
    baseSalary: !val.BaseSalary || val.BaseSalary === '' ? 0 : Number(val.BaseSalary),
    paymentDay: !val.PaymentDay || val.PaymentDay === '' ? 0 : Number(val.PaymentDay)
  }
  console.log('finalData', dataForm.value)

  dataFormLabel.value = {
    employmentTypeName: val.EmploymentType.name,
    employmentType: val.EmploymentType,
    positionName: val.Position.name,
    position: val.Position,
    regionName: val.Region.name,
    region: val.Region,
    buildingName: val.Building.name,
    building: val.Building,
    startDate: moment(val.StartDate).format('YYYY-MM-DD'),
    endDate: val.EndDate ? moment(val.EndDate).format('YYYY-MM-DD') : null,
    remarks: val.Note ? val.Note : '',
    isActive: IsEmployeeActive.value,
    baseSalary: !val.BaseSalary || val.BaseSalary === '' ? 0 : Number(val.BaseSalary),
    paymentDay: !val.PaymentDay || val.PaymentDay === '' ? 0 : Number(val.PaymentDay)
  }
  store.dispatch('employee/setEmployeeContract', dataForm.value)
  store.dispatch('employee/setEmployeeContractLabel', dataFormLabel.value)
  store.dispatch('employee/setEmployeeFormStep', 3)

  console.log('GETEMPCONTRACT', store.getters['employee/getEmployeeContract'])

  // const response = await apiUseCase.postOrPut(employmentEndpoint, null, dataForm.value)
  // console.log('response', response)
  // if (!response.error) {
  //   toast('success', 'Berhasil menyimpan Data Kontrak Divisi')
  //   if (!idPrams.value) store.dispatch('employee/setEmployeeFormStep', 3)
  // } else {
  //   toast('error', 'Gagal menyimpan Data Kontrak Divisi')
  // }
  store.dispatch('hideLoading')
}

const checkDateValidation = (values: any) => {
  if (values.EndDate) {
    IsEmployeeActive.value = false
    initialValues.IsActive = false
    if (values.StartDate > values.EndDate) {
      toast('error', 'Tanggal Mulai tidak bisa lebih besar dari Tanggal Selesai')
    } else if (values.StartDate === values.EndDate) {
      toast('error', 'Tanggal Selesai harus lebih besar dari Tanggal Mulai')
    } else {
      processSubmit(values)
    }
  } else {
    IsEmployeeActive.value = true
    initialValues.IsActive = true
    processSubmit(values)
  }

  if (values.EndDate) {
    IsEmployeeActive.value = false
  } else {
    IsEmployeeActive.value = true
  }
  // console.log('isempactive', IsEmployeeActive.value)
}

const onBack = () => {
  console.log('back')
}

const onSubmit = (values: any) => {
  console.log('submit', values)
  checkDateValidation(values)
}

const checkboxClick = (oldValue: any) => {
  console.log('checkboxClick', oldValue)
  // emit('change', oldValue)
}

const getAllPositions = async () => {
  if (!positionOptions.value) {
    const response = await apiUseCase.get(positionEndpoint)
    // console.log('response', response)
    if (!response.error) {
      positionOptions.value = response.result.data
      console.log('positionOptions', positionOptions.value)
    }
  }
}

const getAllRegions = async () => {
  if (!regionOptions.value) {
    const response = await apiUseCase.get(regionEndpoint)
    // console.log('response', response)
    if (!response.error) {
      regionOptions.value = response.result.data
      console.log('regionOptions', regionOptions)
    }
  }
}

const getAllEmploymentTypes = async () => {
  if (!employmentTypeOptions.value) {
    const response = await apiUseCase.get(employmentTypesEndpoint)
    // console.log('response', response)
    if (!response.error) {
      employmentTypeOptions.value = response.result.data
    }
  }
}

const getData = async () => {
  getAllPositions()
  getAllRegions()
  getAllEmploymentTypes()
}

const getProfile = async () => {
  store.dispatch('showLoading')
  await apiUseCase.get(`${employeeEndpoint}/${idPrams.value.id}`).then((response) => {
    const { error, result } = response
    if (!error) store.dispatch('employee/setEmployeeData', result)
    else console.log('error', error)
  })
  store.dispatch('hideLoading')
}

const checkEmployeeId = async () => {
  try {
    console.log('employeeid from prev', idPrams.value)
    if (!idPrams.value) idPrams.value = store.getters['employee/getEmployeeId']
    console.log('employeeid after load', idPrams.value)
    if (store.getters['employee/getEmployeeData'].fullName === null) getProfile()

    isEmploymentActive.value = store.getters['employee/getEmployeeEmployments'].length
    // console.log('employmenttsss', store.getters['employee/getEmployeeEmployments'])
    // console.log('employmenttsssLENGTH', store.getters['employee/getEmployeeEmployments'].length)
  } catch (e) {
    console.log(e)
  }
}

const changeCheckbox = (status: any, val: any) => {
  IsEmployeeActive.value = status
  initialValues.EndDate = val
}

const check = (val: any, setFieldValue: any) => {
  console.log('check', [val])
  setFieldValue('IsActive', !val)
}

const getPositionRequirements = async (idPosition: string) => {
  store.dispatch('showLoading')
  try {
    await apiUseCase.get(`${positionEndpoint}/${idPosition}/requirements`).then((response) => {
      const { error, result } = response
      if (!error) {
        console.log('resDocReq', result)
        positionRequirementList.value = result
      } else {
        console.log('error')
      }
    })
  } catch (error) {
    console.log('err', error)
  }
  store.dispatch('hideLoading')
}

const onSelectedPosition = (data: any) => {
  // getPositionDetail(data.id)
  getPositionRequirements(data.id)
}

const onNumericInput = (event: Event, field: any, maxLength: number) => {
  const input = event.target as HTMLInputElement
  input.value = input.value.replace(/\D/g, '').slice(0, maxLength)
  field.onInput(event)
}

onMounted(() => {
  // console.log('id', store.getters['employee/getEmployeeId'])
  getData()
  if (route.params.id) {
    idPrams.value = encryptDecriptMethods.decrypt(route.params.id)
    // console.log('STEP 2 masuk route.params.id')

    if (store.getters['employee/getEmployeeData'].fullName === null) getProfile()
    const employment = store.getters['employee/getEmployeeEmployments'][0]
  // getContract
    console.log('employee/getEmployeeContract', store.getters['employee/getEmployeeContract'])
    if (store.getters['employee/getEmployeeContractLabel']) {
      store.dispatch('showLoading')
      contract = store.getters['employee/getEmployeeContractLabel']
      initialValues.Position = contract.position
      initialValues.Region = contract.region
      initialValues.Building = contract.building
      initialValues.EmploymentType = contract.employmentType
      initialValues.StartDate = contract.startDate
      initialValues.EndDate = contract.endDate
      initialValues.Note = contract.remarks
      initialValues.IsActive = contract.isActive
      initialValues.BaseSalary = contract.baseSalary
      initialValues.PaymentDay = contract.paymentDay
      IsEmployeeActive.value = contract.isActive
      store.dispatch('hideLoading')
    } else {
      console.log('TIDAK ADA DATA')
    }

    // if (idPrams.value !== 0 && store.getters['employee/getEmployeeEmployments'].length === 1) {
    //   console.log('employmenttsss', store.getters['employee/getEmployeeEmployments'])
    //   // initialValues.Position = positionOptions.value.filter((item: any) => {
    //   //   item.name.toLowerCase() === employment.positionName.toLowerCase()
    //   // })
    //   // initialValues.Position = employment.positionName
    //   // console.log('inii hasil filter', positionOptions.value.filter((item: any) => item.name.includes(employment.positionName)))
    //   // positionOptions.value = employment.positionName
    //   initialValues.EmploymentType = employment.employmentTypeName
    //   // employmentTypeOptions.value = employment.employmentTypeName
    //   initialValues.Region = employment.regionName
    //   // regionOptions.value = employment.regionName
    //   initialValues.StartDate = employment.startDate
    //   initialValues.EndDate = employment.endDate
    //   initialValues.Note = employment.remarks
    //   // initialValues.IsEmployeeActive
    // }
  }
  isLoading.value = false
})

onBeforeMount(() => {
  contract.value = store.getters['employee/getEmployeeContractLabel']
  console.log('prinnnnn', contract.value)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (idPrams.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(EmployeeContractList)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (!isLoading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _cache[16] || (_cache[16] = _createElementVNode("p", { class: "font-bold text-xl mb-2" }, "Kontrak Divisi", -1)),
                _createVNode(_unref(Form), {
                  onSubmit: onSubmit,
                  "validation-schema": _unref(schema),
                  "initial-values": initialValues,
                  class: "form-container"
                }, {
                  default: _withCtx(({ errors, setFieldValue, values, meta }) => [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, [
                          _createElementVNode("div", _hoisted_7, [
                            _cache[1] || (_cache[1] = _createElementVNode("label", {
                              for: "position",
                              class: "label-text required"
                            }, "Divisi", -1)),
                            _createVNode(_unref(Field), {
                              id: "position",
                              name: "Position",
                              class: _normalizeClass(`input-primary ${errors.LastEducation ? 'input-invalid' : ''}`),
                              validateOnInput: true
                            }, {
                              default: _withCtx(() => [
                                _createVNode(SelectAsync, {
                                  modelValue: values.Position,
                                  "onUpdate:modelValue": [($event: any) => ((values.Position) = $event), (val) => setFieldValue(`Position`, val)],
                                  inputId: `position`,
                                  endpoint: positionEndpoint,
                                  fieldLabel: (v) => `${v.name}`,
                                  fieldValue: 'id',
                                  clearable: false,
                                  searchFields: ['name'],
                                  placeholder: `Pilih Divisi`,
                                  classname: 'custom-select',
                                  onChange: _cache[0] || (_cache[0] = (val) => onSelectedPosition(val))
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "fieldLabel"])
                              ]),
                              _: 2
                            }, 1032, ["class"]),
                            _createElementVNode("div", _hoisted_8, _toDisplayString(errors.Position), 1)
                          ]),
                          _createElementVNode("div", _hoisted_9, [
                            _cache[2] || (_cache[2] = _createElementVNode("label", {
                              for: "employmentType",
                              class: "label-text required"
                            }, "Jenis Kepegawaian", -1)),
                            _createVNode(_unref(Field), {
                              id: "employmentType",
                              name: "EmploymentType",
                              class: _normalizeClass(`input-primary ${errors.EmploymentType ? 'input-invalid' : ''}`),
                              validateOnInput: true
                            }, {
                              default: _withCtx(() => [
                                _createVNode(SelectAsync, {
                                  modelValue: values.EmploymentType,
                                  "onUpdate:modelValue": [($event: any) => ((values.EmploymentType) = $event), (val) => setFieldValue(`EmploymentType`, val)],
                                  inputId: `employmentType`,
                                  endpoint: employmentTypesEndpoint,
                                  fieldLabel: (v) => `${v.name}`,
                                  fieldValue: 'id',
                                  clearable: false,
                                  searchFields: ['name'],
                                  placeholder: `Pilih jenis kepegawaian`,
                                  classname: 'custom-select'
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "fieldLabel"])
                              ]),
                              _: 2
                            }, 1032, ["class"]),
                            _createElementVNode("div", _hoisted_10, _toDisplayString(errors.EmploymentType), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("div", _hoisted_12, [
                            _cache[3] || (_cache[3] = _createElementVNode("label", {
                              for: "region",
                              class: "label-text required"
                            }, "Wilayah Operasional", -1)),
                            _createVNode(_unref(Field), {
                              id: "region",
                              name: "Region",
                              class: _normalizeClass(`input-primary ${errors.Region ? 'input-invalid' : ''}`),
                              validateOnInput: true
                            }, {
                              default: _withCtx(() => [
                                _createVNode(SelectAsync, {
                                  modelValue: values.Region,
                                  "onUpdate:modelValue": [($event: any) => ((values.Region) = $event), (val) => setFieldValue(`Region`, val)],
                                  inputId: `region`,
                                  endpoint: regionEndpoint,
                                  fieldLabel: (v) => `${v.name}`,
                                  fieldValue: 'id',
                                  clearable: false,
                                  searchFields: ['name'],
                                  placeholder: `Pilih wilayah operasional`,
                                  classname: 'custom-select'
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "fieldLabel"])
                              ]),
                              _: 2
                            }, 1032, ["class"]),
                            _createElementVNode("div", _hoisted_13, _toDisplayString(errors.Region), 1)
                          ]),
                          _createElementVNode("div", _hoisted_14, [
                            _cache[4] || (_cache[4] = _createElementVNode("label", {
                              for: "building",
                              class: "label-text required"
                            }, "Kantor Kerja", -1)),
                            _createVNode(_unref(Field), {
                              id: "building",
                              name: "Building",
                              class: _normalizeClass(`input-primary ${errors.building ? 'input-invalid' : ''}`),
                              validateOnInput: true
                            }, {
                              default: _withCtx(({ field }) => [
                                _createVNode(SelectAsync, _mergeProps(field, {
                                  inputId: `building`,
                                  endpoint: `${buildingEndpoint}`,
                                  fieldLabel: (v) => `${v.name}`,
                                  modelValue: values.Building,
                                  clearable: true,
                                  searchFields: ['name'],
                                  placeholder: `Pilih Gedung`,
                                  classname: 'custom-select',
                                  disabled: false,
                                  "search-custom": [['isActive', '=', 'true']]
                                }), null, 16, ["endpoint", "fieldLabel", "modelValue"])
                              ]),
                              _: 2
                            }, 1032, ["class"]),
                            _createElementVNode("div", _hoisted_15, _toDisplayString(errors.Building), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_16, [
                          _createElementVNode("div", _hoisted_17, [
                            _createElementVNode("div", null, [
                              _cache[5] || (_cache[5] = _createElementVNode("label", {
                                for: "startDate",
                                class: "label-text required"
                              }, "Tanggal Mulai", -1)),
                              _createVNode(_unref(Field), { name: "StartDate" }, {
                                default: _withCtx(({ field }) => [
                                  _createVNode(_unref(DatePicker), _mergeProps(field, {
                                    modelValue: values.StartDate,
                                    "onUpdate:modelValue": [($event: any) => ((values.StartDate) = $event), (val) => setFieldValue('StartDate', val)],
                                    masks: {
                          input: 'DD/MM/YYYY'
                        }
                                  }), {
                                    default: _withCtx(({ togglePopover, inputValue, inputEvents }) => [
                                      _createVNode(_unref(InputText), _mergeProps({
                                        id: "startDate",
                                        "aria-describedby": "startDate-help",
                                        placeholder: "DD/MM/YYYY",
                                        value: inputValue,
                                        class: `input-primary ${errors.StartDate ? 'input-invalid' : ''}`
                                      }, _toHandlers(inputEvents), { onClick: togglePopover }), null, 16, ["value", "class", "onClick"])
                                    ]),
                                    _: 2
                                  }, 1040, ["modelValue", "onUpdate:modelValue"])
                                ]),
                                _: 2
                              }, 1024),
                              _createElementVNode("div", _hoisted_18, _toDisplayString(errors.StartDate), 1)
                            ]),
                            _createElementVNode("div", _hoisted_19, [
                              _createVNode(_unref(Checkbox), {
                                modelValue: values.IsActive,
                                "onUpdate:modelValue": [($event: any) => ((values.IsActive) = $event), (val) => val ? setFieldValue('EndDate', null) : ''],
                                inputId: "IsEmployeeActive",
                                binary: true,
                                onChange: (val) => check(values.IsActive, setFieldValue)
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"]),
                              _cache[6] || (_cache[6] = _createElementVNode("label", {
                                for: "IsEmployeeActive",
                                class: "ml-2"
                              }, "Kontrak Karyawan masih aktif", -1))
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_20, [
                            _createElementVNode("div", null, [
                              _cache[7] || (_cache[7] = _createElementVNode("label", {
                                for: "endDate",
                                class: "label-text"
                              }, "Tanggal Selesai", -1)),
                              _createVNode(_unref(Field), { name: "EndDate" }, {
                                default: _withCtx(({ field }) => [
                                  _createVNode(_unref(DatePicker), _mergeProps(field, {
                                    modelValue: values.EndDate,
                                    "onUpdate:modelValue": [($event: any) => ((values.EndDate) = $event), (val) => val ? values.IsActive=false : ''],
                                    disabled: values.IsActive,
                                    masks: {
                          input: 'DD/MM/YYYY'
                        }
                                  }), {
                                    default: _withCtx(({ togglePopover, inputValue }) => [
                                      _createVNode(_unref(InputText), {
                                        id: "endDate",
                                        "aria-describedby": "endDate-help",
                                        placeholder: "DD/MM/YYYY",
                                        value: inputValue,
                                        class: _normalizeClass(`input-primary ${errors.EndDate ? 'input-invalid' : ''}`),
                                        onClick: togglePopover,
                                        disabled: values.IsActive
                                      }, null, 8, ["value", "class", "onClick", "disabled"])
                                    ]),
                                    _: 2
                                  }, 1040, ["modelValue", "onUpdate:modelValue", "disabled"])
                                ]),
                                _: 2
                              }, 1024),
                              _createElementVNode("div", _hoisted_21, _toDisplayString(errors.EndDate), 1)
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_22, [
                          _createElementVNode("div", _hoisted_23, [
                            _cache[8] || (_cache[8] = _createElementVNode("label", {
                              for: "note",
                              class: "label-text required"
                            }, "Keterangan", -1)),
                            _createVNode(_unref(Field), {
                              id: "note",
                              name: "Note",
                              as: "textarea",
                              type: "text",
                              placeholder: "Ex. Jl. Harapan Blok J4-Y4, Tulungagung",
                              class: "input-primary",
                              modelValue: values.Note,
                              "onUpdate:modelValue": ($event: any) => ((values.Note) = $event),
                              validateOnInput: true,
                              rows: "5"
                            }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                            _createElementVNode("div", _hoisted_24, _toDisplayString(errors.Note), 1)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("div", _hoisted_26, [
                          (values.Position)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                _createElementVNode("div", _hoisted_28, [
                                  _cache[9] || (_cache[9] = _createElementVNode("div", { class: "text-base text-grey" }, "Divisi:", -1)),
                                  _createElementVNode("div", _hoisted_29, _toDisplayString(values.Position?.name) + " " + _toDisplayString(`(${values.Position?.code})`), 1)
                                ]),
                                _cache[10] || (_cache[10] = _createElementVNode("div", { class: "font-semibold text-base mt-3" }, "Persyaratan Umum", -1)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(positionRequirementList.value, (data) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: data,
                                    class: "md:flex gap-4 mt-2"
                                  }, [
                                    _createElementVNode("div", _hoisted_30, _toDisplayString(data.requirementName), 1),
                                    _createElementVNode("div", _hoisted_31, _toDisplayString(data.requirementDataType === 'Integer' ? _unref(numberFormat)(data.dataValue) : data.dataValue), 1)
                                  ]))
                                }), 128))
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_32, _cache[11] || (_cache[11] = [
                                _createElementVNode("div", { class: "text-center w-2/3" }, [
                                  _createElementVNode("img", {
                                    class: "mx-auto",
                                    src: _imports_0,
                                    alt: "position"
                                  }),
                                  _createElementVNode("div", { class: "text-xl font-semibold" }, "Persyaratan Umum"),
                                  _createElementVNode("div", { class: "text-sm text-grey" }, "Pilih Divisi untuk menampilkan informasi persyaratan umum dari Divisi tersebut")
                                ], -1)
                              ])))
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_33, [
                      _createElementVNode("div", _hoisted_34, [
                        _cache[13] || (_cache[13] = _createElementVNode("label", {
                          for: "baseSalary",
                          class: "label-text"
                        }, "Gaji per Bulan", -1)),
                        _createVNode(_unref(Field), {
                          id: "baseSalary",
                          name: "BaseSalary",
                          class: _normalizeClass(`input-primary ${errors.BaseSalary ? 'input-invalid' : ''}`),
                          validateOnInput: true
                        }, {
                          default: _withCtx(({ field }) => [
                            _createElementVNode("div", _hoisted_35, [
                              _cache[12] || (_cache[12] = _createElementVNode("span", { class: "p-inputgroup-addon" }, _toDisplayString('Rp.'), -1)),
                              _createVNode(_unref(InputText), _mergeProps({
                                class: `input-primary ${errors.BaseSalary ? 'input-invalid' : ''}`,
                                id: "baseSalary"
                              }, field, {
                                "aria-describedby": "base-salary-help",
                                placeholder: "0",
                                type: "text",
                                inputmode: "numeric",
                                maxlength: "10",
                                onInput: (event) => onNumericInput(event, field, 10)
                              }), null, 16, ["class", "onInput"])
                            ])
                          ]),
                          _: 2
                        }, 1032, ["class"]),
                        _createElementVNode("div", _hoisted_36, _toDisplayString(errors.BaseSalary), 1)
                      ]),
                      _createElementVNode("div", _hoisted_37, [
                        _cache[14] || (_cache[14] = _createElementVNode("label", {
                          for: "paymentDay",
                          class: "label-text"
                        }, "Tanggal Pembayaran per Bulan", -1)),
                        _createVNode(_unref(Field), {
                          id: "paymentDay",
                          name: "PaymentDay",
                          class: _normalizeClass(`input-primary ${errors.PaymentDay ? 'input-invalid' : ''}`),
                          validateOnInput: true
                        }, {
                          default: _withCtx(({ field }) => [
                            _createVNode(_unref(InputText), _mergeProps({
                              class: `input-primary ${errors.PaymentDay ? 'input-invalid' : ''}`,
                              id: "paymentDay"
                            }, field, {
                              "aria-describedby": "payment-day-help",
                              placeholder: "0",
                              type: "text",
                              inputmode: "numeric",
                              maxlength: "2",
                              onInput: (event) => onNumericInput(event, field, 2)
                            }), null, 16, ["class", "onInput"])
                          ]),
                          _: 2
                        }, 1032, ["class"]),
                        _createElementVNode("div", _hoisted_38, _toDisplayString(errors.PaymentDay), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_39, [
                      _createVNode(_unref(Button), {
                        type: "submit",
                        class: "btn-primary mr-1",
                        disabled: (meta.valid && false)
                      }, {
                        default: _withCtx(() => _cache[15] || (_cache[15] = [
                          _createTextVNode("Lanjut")
                        ])),
                        _: 2,
                        __: [15]
                      }, 1032, ["disabled"])
                    ])
                  ]),
                  _: 1
                }, 8, ["validation-schema"])
              ]))
            : _createCommentVNode("", true)
        ]))
  ]))
}
}

})